import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'en', name: t('languages.en'), flag: '🇺🇸' },
    { code: 'sr', name: t('languages.sr'), flag: '🇷🇸' },
    { code: 'sk', name: t('languages.sk'), flag: '🇸🇰' },
    { code: 'hu', name: t('languages.hu'), flag: '🇭🇺' },
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className="language-selector" style={{
      position: 'relative',
      display: 'inline-block',
      width: '100%'
    }}>
      <button
        className="btn dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.15)',
          color: '#fff',
          padding: '8px 12px',
          borderRadius: '6px',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          width: '100%',
          justifyContent: 'space-between'
        }}
      >
        <span>{languages.find(lang => lang.code === i18n.language)?.flag || '🌐'}</span>
        <span style={{ flex: 1, textAlign: 'left' }}>
          {languages.find(lang => lang.code === i18n.language)?.name || 'English'}
        </span>
        <span style={{ fontSize: '10px' }}>▼</span>
      </button>
      
      <ul className="dropdown-menu" style={{
        background: 'rgba(0,0,0,0.95)',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '8px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        backdropFilter: 'blur(10px)',
        minWidth: '180px',
        padding: '8px 0',
        marginTop: '5px'
      }}>
        {languages.map((language) => (
          <li key={language.code}>
            <button
              className="dropdown-item"
              onClick={() => handleLanguageChange(language.code)}
              style={{
                background: 'none',
                border: 'none',
                color: i18n.language === language.code ? '#4CAF50' : 'rgba(255,255,255,0.9)',
                padding: '8px 16px',
                width: '100%',
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                fontSize: '13px',
                cursor: 'pointer',
                fontWeight: i18n.language === language.code ? '600' : '400',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(76, 175, 80, 0.1)';
                e.currentTarget.style.color = '#4CAF50';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'none';
                e.currentTarget.style.color = i18n.language === language.code ? '#4CAF50' : 'rgba(255,255,255,0.9)';
              }}
            >
              <span>{language.flag}</span>
              <span>{language.name}</span>
              {i18n.language === language.code && (
                <span style={{ marginLeft: 'auto', fontSize: '10px' }}>✓</span>
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageSelector; 